import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import en from './locale/en/translation.json';
import pl from './locale/pl/translation.json';

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .init({
    backend: {
      loadPath: '/locale/{{lng}}/{{ns}}.json', // assumes translation files are served from public/locale
    },
    resources: {
      en: {
        translation: en
      },
      pl: {
        translation: pl
      }
    },
    debug: false,
    namespace: 'translation',
    lng: 'en',
    saveMissing: true,
    saveMissingTo: 'all',
    fallbackLng: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
